module.exports = __webpack_public_path__ + "img/event-single-3.bbf7a50a.svg";